import {ACTIONS} from "../actions/_actions_types";

const initialState = {
    all: [],
    current: {},
    searched: {},
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;

        case ACTIONS.LOT_OF_SALE.GET_ALL:
            return Object.assign({}, state, {
                all: action.payload,
                searched: [],
            });
        case ACTIONS.LOT_OF_SALE.POST:
            state.all.push(action.payload);
            return {...state};

        case ACTIONS.LOT_OF_SALE.PUT:
            state.all = state.all.filter(lot => lot.id_lot_sale !== action.payload.lot_of_sale.id_lot_sale);
            state.all.push(action.payload.lot)
            return {...state};

        case ACTIONS.LOT_OF_SALE.DELETE:
            state.all = state.all.filter(lot => lot.id_lot_sale !== action.payload.id);
            return Object.assign({}, state, {
                all: state.all
            });

        case ACTIONS.LOT_OF_SALE.GET:
            return Object.assign({}, state, {
                current: action.payload
            });

        case ACTIONS.LOT_OF_SALE.SEARCH:
            return Object.assign({}, state, {
                searched: action.payload.data
            });

        case ACTIONS.ERROR:
            console.dir(action.payload.data);
    }
}
